<template>
  <div class="footer">
    <!--<slot>&copy; Copyright Otomo 2020 | <a href="https://otomo.io/privacy.html" target="_blank">Privacy Policy</a></slot>-->
  </div>
</template>

<script>
export default {
  name: 'Footer',
  components: {},
  props: {},
  mounted () {},
  data: () => ({})
}
</script>

<style lang="scss">
    @import "./footer";
</style>



// WEBPACK FOOTER //
// src/components/Footer/footer.vue